"use strict";
(self["webpackChunkpop_and_bottle"] = self["webpackChunkpop_and_bottle"] || []).push([[150],{

/***/ 150:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ marquee)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
  JS Section: sections/marquee.liquid, 
  * JS Elements: [data-section="marquee"] and [data-hook="marquee-track"]
  * Populates the marquee with duplicate tracks to fill the screen
  * Turns `on` the marquee wrapper
  * 
  * TODO: responsive window size change
  * TODO: accessible play & pause buttons like on slider components.
*/

function marquee({ wrapper }) {
  const cache = {
    $wrapper: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper),
    $track: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-hook="marquee-track"]'),
  }

    ; (function initializeClones() {
      createTrackClone()
    })()

  function createTrackClone() {
    let width = cache.$wrapper.width()
    let trackWidth = cache.$track.width()
    let widthDivider = Math.ceil(width / trackWidth)

    for (let index = 0; index < widthDivider; index++) {
      let $clone = cache.$track.clone()
      $clone.attr('aria-hidden', true)

      cache.$wrapper.append($clone)
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).addClass('on')
  }
}


/***/ })

}]);